import { useWalletBook } from '@dynamic-labs/wallet-book';
import WalletConnect from '../wallets/walletConnect/walletConnect.js';
import WalletConnectV2 from '../wallets/walletConnect/walletConnectV2.js';

const fetchWalletConnectWallets = (evmNetworks, isV2Enabled) => Object.values(useWalletBook().wallets)
    .filter((wallet) => wallet.walletConnect)
    .map((wallet) => {
    var _a;
    const { shortName } = wallet;
    const name = shortName || wallet.name;
    let connector;
    // justification: we filtered out null/undefined above
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (isV2Enabled && ((_a = wallet.walletConnect.sdks) === null || _a === void 0 ? void 0 : _a.includes('sign_v2'))) {
        connector = new WalletConnectV2({
            evmNetworks,
            walletName: name,
        });
    }
    else {
        connector = new WalletConnect({ evmNetworks, walletName: name });
    }
    return connector;
});

export { fetchWalletConnectWallets };
